document.addEventListener("DOMContentLoaded",()=>{
  const popup=document.getElementById("RyokaPopup");
  if(popup){
    document.body.classList.add("ryoka-popup-open");
    popup.style.display="flex";
    const closeButtons=popup.querySelectorAll("[data-popup-close]");
    closeButtons.forEach(btn=>btn.addEventListener("click",()=>{
      popup.style.display="none";
      document.body.classList.remove("ryoka-popup-open");
    }));
  }

  document.querySelectorAll("[data-countdown]").forEach(el=>{
    const date=new Date(el.dataset.countdown);
    const tick=()=>{
      let d=date-new Date();
      if(d<0)d=0;
      const s=Math.floor(d/1000);
      el.querySelector("[data-days]").textContent=String(Math.floor(s/86400)).padStart(2,"0");
      el.querySelector("[data-hours]").textContent=String(Math.floor(s%86400/3600)).padStart(2,"0");
      el.querySelector("[data-minutes]").textContent=String(Math.floor(s%3600/60)).padStart(2,"0");
      el.querySelector("[data-seconds]").textContent=String(s%60).padStart(2,"0");
    };
    tick(); setInterval(tick,1000);
  });

  const viewers=document.querySelector("[data-viewers]");
  if(viewers){
    let n=7;
    setInterval(()=>{
      n+=Math.random()>.5?1:-1;
      n=Math.max(4,Math.min(18,n));
      viewers.textContent=n;
    },5000);
  }
});